import React from 'react';
import { Link } from 'react-router-dom';

import { ArrowRight, CheckCircle2, Award, Users, Target, Zap } from 'lucide-react';
import CountUp from 'react-countup';
import './ModernAbout.scss';

const ModernAbout = () => {
    const stats = [
        { number: 500, suffix: '+', label: 'Clients Served' },
        { number: 15, suffix: '+', label: 'Years Experience' },
        { number: 50, suffix: '+', label: 'Partners' },
        { number: 99, suffix: '%', label: 'Satisfaction' },
    ];

    const highlights = [
        'Government Authorized Reseller',
        'Enterprise IT Solutions',
        'Certified Technology Partners',
        '24/7 Support Services',
    ];

    return (
        <section className="jk-about" id="about">
            <div className="jk-about__container">
                <div className="jk-about__grid">
                    {/* Left Content */}
                    <div className="jk-about__content">
                        <span className="jk-section-label">
                            <Award size={16} />
                            About Jaak Tech
                        </span>

                        <h2 className="jk-about__title">
                            Your Trusted Technology
                            <span className="jk-about__title-highlight"> Partner</span>
                        </h2>

                        <p className="jk-about__description">
                            Jaak Tech is a leading authorized technology reseller, providing
                            comprehensive IT solutions to government agencies, healthcare organizations,
                            and commercial enterprises. We simplify technology procurement and
                            implementation so you can focus on your mission.
                        </p>

                        <p className="jk-about__description">
                            With over 15 years of experience, we've built lasting partnerships with
                            top technology vendors to deliver best-in-class hardware, software, and
                            services tailored to your unique needs.
                        </p>

                        {/* Highlights */}
                        <ul className="jk-about__highlights">
                            {highlights.map((item, index) => (
                                <li key={index} className="jk-about__highlight">
                                    <CheckCircle2 size={20} className="jk-about__highlight-icon" />
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>

                        <Link to="/about" className="jk-btn jk-btn--primary">
                            Learn More About Us
                            <ArrowRight size={20} />
                        </Link>
                    </div>

                    {/* Right - Visual Grid */}
                    <div className="jk-about__visual">
                        <div className="jk-about__cards">
                            <div className="jk-about__card jk-about__card--primary">
                                <div className="jk-about__card-icon">
                                    <Target size={32} />
                                </div>
                                <h3 className="jk-about__card-title">Our Mission</h3>
                                <p className="jk-about__card-text">
                                    Simplify technology adoption for organizations of all sizes
                                </p>
                            </div>

                            <div className="jk-about__card">
                                <div className="jk-about__card-icon jk-about__card-icon--blue">
                                    <Users size={32} />
                                </div>
                                <h3 className="jk-about__card-title">Expert Team</h3>
                                <p className="jk-about__card-text">
                                    Certified professionals dedicated to your success
                                </p>
                            </div>

                            <div className="jk-about__card">
                                <div className="jk-about__card-icon jk-about__card-icon--cyan">
                                    <Zap size={32} />
                                </div>
                                <h3 className="jk-about__card-title">Fast Delivery</h3>
                                <p className="jk-about__card-text">
                                    Quick procurement and deployment solutions
                                </p>
                            </div>

                            <div className="jk-about__card jk-about__card--dark">
                                <div className="jk-about__card-icon jk-about__card-icon--light">
                                    <Award size={32} />
                                </div>
                                <h3 className="jk-about__card-title">Certified</h3>
                                <p className="jk-about__card-text">
                                    Government authorized and industry certified
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Stats Bar */}
                <div className="jk-about__stats">
                    {stats.map((stat, index) => (
                        <div key={index} className="jk-about__stat">
                            <span className="jk-about__stat-number">
                                <CountUp end={stat.number} duration={2.5} enableScrollSpy scrollSpyOnce />
                                {stat.suffix}
                            </span>
                            <span className="jk-about__stat-label">{stat.label}</span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ModernAbout;
